import { Link } from '@tanstack/react-router';

import { HStack, VStack } from '@/components/Layout';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { LabelApp } from '../LabelApp/LabelApp';

export type AppIntegrationPreviewData = {
  /**
   * アプリ連携ID
   */
  id: string;
  /**
   * アプリ名
   */
  appName: string;
  /**
   * テナント名
   */
  tenantName?: string;
  /**
   * アバターURL
   */
  avatarUrl?: string;
};

type Props = {
  /**
   * アプリ連携情報
   */
  appIntegration: AppIntegrationPreviewData;
  /**
   * 「プロフィールを見る」リンクの表示可否
   */
  showProfileLink?: boolean;
  /**
   * リンク表示テキスト
   */
  linkText?: string;
  /**
   * クラス名
   */
  className?: string;
};

/**
 * 人物プレビューカードのコンテンツコンポーネント
 */
export function AppIntegrationPreviewContent({
  appIntegration,
  showProfileLink = true,
  linkText,
  className,
}: Props) {
  const { t } = useTranslation(defaultNS);

  return (
    <VStack className={className}>
      <VStack className="gap-2 max-w-2xl">
        <HStack className="items-center gap-2">
          <LabelApp
            name={appIntegration.appName}
            avatarUrl={appIntegration.avatarUrl}
            tenantName={appIntegration.tenantName}
          />
        </HStack>
      </VStack>
      {showProfileLink && appIntegration.id && (
        <HStack className="mt-2 justify-end">
          <Link
            to="/app-integrations/$id"
            params={{ id: appIntegration.id }}
            className="flex items-center justify-center font-semibold text-muted-foreground hover:text-primary capitalize"
          >
            {linkText ||
              t('component.appIntegrationPreviewContent.goToProfile')}
          </Link>
        </HStack>
      )}
    </VStack>
  );
}
